import { render, staticRenderFns } from "./CanvasIcons.vue?vue&type=template&id=2d2e0266&scoped=true&"
import script from "./CanvasIcons.vue?vue&type=script&lang=js&"
export * from "./CanvasIcons.vue?vue&type=script&lang=js&"
import style0 from "./CanvasIcons.vue?vue&type=style&index=0&id=2d2e0266&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e0266",
  null
  
)

export default component.exports